module.exports = __webpack_public_path__ + "static/media/info.92539c42.svg";